import httpClient from './httpClient'
import axios from 'axios'
import { CONFIG_URL } from '@/config/envs.js'

export default {
  async createTranslation({
    fromLang,
    videoId,
    toLangs,
    isLipSync,
    numberOfVoices,
    cloneOriginalVoice,
    enableDynamicDuration,
    enhanceVoiceQuality,
    removeBackgroundMusic,
  }) {
    let requestConfig = toLangs.map((item) => ({
      type: 'TRANSLATION',
      from_lang: fromLang,
      video_id: videoId,
      to_lang: item.toLang,
      is_lipsync: isLipSync,
      num_speakers: numberOfVoices,
      clone_original_voice: cloneOriginalVoice,
      enable_dynamic_duration: enableDynamicDuration,
      enhance_voice_quality: enhanceVoiceQuality,
      remove_background_music: removeBackgroundMusic,
      ...(item.additionalConfig ? item.additionalConfig : {}),
    }))

    const ret = await httpClient.post('/aiworkflow', requestConfig)
    if (Array.isArray(ret.data)) {
      ret.data.forEach((item) => {
        const newItem = {
          ...item,
          metadata: {
            ...item,
            from_lang: item.to_lang || item.to_lang,
          },
          status: 'QUEUE',
        }
        const existing =
          JSON.parse(sessionStorage.getItem(`dubbing_${videoId}`)) || []
        const updated = Array.isArray(existing)
          ? [...existing, newItem]
          : [newItem]

        sessionStorage.setItem(`dubbing_${videoId}`, JSON.stringify(updated))
      })
    } else {
      const newItem = {
        ...ret.data,
        metadata: { ...ret.data, from_lang: ret.data.to_lang },
        status: 'QUEUE',
      }
      const existing =
        JSON.parse(sessionStorage.getItem(`dubbing_${videoId}`)) || []

      const updated = Array.isArray(existing)
        ? [...existing, newItem]
        : [newItem]

      sessionStorage.setItem(`dubbing_${videoId}`, JSON.stringify(updated))
    }
    return ret
  },
  async createTranscription({
    fromLang,
    videoId,
    ctx,
    additionalLangs,
    additionalConfig,
    isLipSync,
    numberOfVoices,
    cloneOriginalVoice,
    enableDynamicDuration,
    enhanceVoiceQuality,
    removeBackgroundMusic,
  }) {
    let fromLangMethod = fromLang
    if (fromLangMethod === 'pt-br') fromLangMethod = 'pt-BR'
    let requestConfig = {
      type: 'TRANSCRIPTION',
      from_lang: fromLangMethod,
      additional_langs: additionalLangs,
      video_id: videoId,
      is_lipsync: isLipSync,
      num_speakers: numberOfVoices,
      clone_original_voice: cloneOriginalVoice,
      enable_dynamic_duration: enableDynamicDuration,
      enhance_voice_quality: enhanceVoiceQuality,
      remove_background_music: removeBackgroundMusic,
      ctx,
    }
    // eslint-disable-next-line no-extra-boolean-cast
    if (!!additionalConfig)
      requestConfig = { ...requestConfig, ...additionalConfig }
    const ret = await httpClient.post('/aiworkflow', requestConfig)

    const newItem = {
      ...ret.data,
      metadata: {
        ...ret.data,
        from_lang: ret.data?.to_lang || additionalLangs[0]?.lang,
      },
      status: 'QUEUE',
    }
    if (Array.isArray(additionalLangs)) {
      additionalLangs.forEach((item) => {
        const newItem = {
          ...ret.data,
          metadata: {
            ...ret.data,
            from_lang: item.lang,
          },
          status: 'QUEUE',
        }
        const existing =
          JSON.parse(sessionStorage.getItem(`dubbing_${videoId}`)) || []
        const updated = Array.isArray(existing)
          ? [...existing, newItem]
          : [newItem]

        sessionStorage.setItem(`dubbing_${videoId}`, JSON.stringify(updated))
      })
    } else {
      const existing =
        JSON.parse(sessionStorage.getItem(`dubbing_${videoId}`)) || []

      const updated = Array.isArray(existing)
        ? [...existing, newItem]
        : [newItem]

      sessionStorage.setItem(`dubbing_${videoId}`, JSON.stringify(updated))
    }
    return ret
  },
  async getAiWorkflow(videoId) {
    try {
      const ret = await httpClient.get(
        `/aiworkflow${videoId ? '?video_id=' + videoId : ''}`
      )
      return ret
    } catch (error) {
      return error
    }
  },
  async deleteAiWorkflow(id) {
    const ret = await httpClient.delete(`/aiworkflow/${id}`)
    return ret
  },
  async createDubbing({
    fromLangs,
    videoId,
    isLipSync,
    numberOfVoices,
    cloneOriginalVoice,
    enableDynamicDuration,
    enhanceVoiceQuality,
    removeBackgroundMusic,
    replaceExistingSubtitles,
  }) {
    const requestConfig = fromLangs.map((item) => ({
      type: 'DUBBING',
      from_lang: item.srclang,
      video_id: videoId,
      background_sound_mode: 'ai',
      voice_id: item.voiceId,
      is_lipsync: isLipSync,
      num_speakers: numberOfVoices,
      clone_original_voice: cloneOriginalVoice,
      enable_dynamic_duration: enableDynamicDuration,
      enhance_voice_quality: enhanceVoiceQuality,
      remove_background_music: removeBackgroundMusic,
      replace_existing_subtitles: replaceExistingSubtitles,
    }))
    const response = await httpClient.post('/aiworkflow', requestConfig)

    const newItem = {
      ...response.data,
      metadata: { ...response.data, from_lang: response.data.to_lang },
      status: 'QUEUE',
    }

    const existing =
      JSON.parse(sessionStorage.getItem(`dubbing_${videoId}`)) || []

    const updated = Array.isArray(existing) ? [...existing, newItem] : [newItem]

    sessionStorage.setItem(`dubbing_${videoId}`, JSON.stringify(updated))

    return response
  },
  async createAiWorkFlow({ fromLang, videoId, additionalConfig }) {
    let requestConfig = {
      type: 'ALL_TEXT_ITEMS',
      from_lang: fromLang,
      video_id: videoId,
    }
    // eslint-disable-next-line no-extra-boolean-cast
    if (!!additionalConfig) {
      requestConfig = { ...requestConfig, ...additionalConfig }
    }
    const ret = await httpClient.post('/aiworkflow', requestConfig)
    sessionStorage.setItem(
      `all_text_items_${videoId}`,
      JSON.stringify(ret.data)
    )
    return ret
  },
  async getAiWorkFlowData(pullzoneName, videoID) {
    try {
      const { data } = await axios.get(
        `${CONFIG_URL}/${pullzoneName}/${videoID}-ai.json?date=${new Date().getTime()}`
      )
      return data
    } catch (error) {
      return error
    }
  },
  async updateAiWorkFlowData(aiData) {
    try {
      const ret = await httpClient.put('/aiworkflow/aipackage', aiData)
      return ret
    } catch (error) {
      return error
    }
  },
  async getDataByFolderId(folderId) {
    try {
      const ret = await httpClient.get(`/aiworkflow?folder_id=${folderId}`)
      return ret
    } catch (error) {
      return error
    }
  },
}
